export const postRequest = (url, body)=> {
    return new Promise((res, rej)=> {
        let http = new XMLHttpRequest();
        http.open('POST', url);
        http.setRequestHeader('Content-Type', 'application/json');
        http.onreadystatechange = ()=> {
            if(http.readyState == XMLHttpRequest.DONE) {
                if(http.status == 200)
                    res(http.response);
                else
                    rej(http.response);
            }
        };
        http.send(JSON.stringify(body));
    });
};

export const getRequest = (url)=> {
    return new Promise((res, rej)=> {
        let http = new XMLHttpRequest();
        http.open('GET', url);
        http.setRequestHeader('Content-Type', 'application/json');
        http.onreadystatechange = ()=> {
            if(http.readyState == XMLHttpRequest.DONE) {
                if(http.status == 200)
                    res(http.response);
                else
                    rej(http.response);
            }
        };
        http.send();
    });
};
